import React from "react";
import { useLocation } from "react-router";

const Loader = () => {
  const location = useLocation();
  const isAdminDashboard = location.pathname === "/admin/dashboard";
  return (
    <div className={`preloader ${isAdminDashboard ? "dashboard-loader" : ""}`}>
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
